<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 960 960">
    <title>Vai</title>
    <path
      d="M346.11 679.56c-13.28 13.223-34.778 13.157-47.992-.123-13.223-13.288-13.157-34.786.123-48L449.92 480.143 298.249 328.849c-13.28-13.214-13.345-34.712-.123-48 13.214-13.28 34.712-13.345 47.992-.123L522.034 456.2c13.223 13.288 13.157 34.786-.123 48L346.118 679.552h0l-.008.008zM637.962 238h0c18.665 0 33.796 15.131 33.796 33.796v416.407c0 18.665-15.131 33.796-33.796 33.796h0c-18.665 0-33.796-15.131-33.796-33.796V271.796c0-18.665 15.131-33.796 33.796-33.796z"
      fill="currentColor"
    />
  </svg>
</template>

<script>
export default {};
</script>
